import { Injectable } from '@angular/core'
import { StorageService } from './storage.service'
import { LogService } from 'htv-lib'
import { BehaviorSubject } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class StateDataService {
  private _deviceId?: string
  deviceId$ = new BehaviorSubject<string | undefined>(undefined)
  readonly deviceIdKey = 'State-deviceId'
  public get deviceId(): string | undefined {
    return this._deviceId
  }
  public set deviceId(value: string | undefined) {
    this._deviceId = value
    this.deviceId$.next(this._deviceId)
    if (this._deviceId) {
      this.storageService.saveString(this.deviceIdKey, this._deviceId)
    } else {
      this.storageService.removeValue(this.deviceIdKey)
    }
  }

  private _customerId?: string
  readonly customerIdKey = 'State-customerId'
  public get customerId(): string | undefined {
    return this._customerId
  }
  public set customerId(value: string | undefined) {
    this._customerId = value
    if (this._customerId) {
      this.storageService.saveString(this.customerIdKey, this._customerId)
    } else {
      this.storageService.removeValue(this.customerIdKey)
    }
  }

  private _guestMode!: boolean
  readonly guestModeKey = 'State-guestMode'
  public get guestMode(): boolean {
    return this._guestMode
  }
  public set guestMode(value: boolean) {
    this._guestMode = value
    this.storageService.saveBoolean(this.guestModeKey, this._guestMode)
  }

  private _checkInState!: boolean
  readonly checkInStateKey = 'State-checkInState'
  public get checkInState(): boolean {
    return this._checkInState
  }
  public set checkInState(value: boolean) {
    this._checkInState = value
    this.storageService.saveBoolean(this.checkInStateKey, this._checkInState)
  }

  private _checkOutState!: boolean
  readonly checkOutStateKey = 'State-checkOutState'
  public get checkOutState(): boolean {
    return this._checkOutState
  }
  public set checkOutState(value: boolean) {
    this._checkOutState = value
    this.storageService.saveBoolean(this.checkOutStateKey, this._checkOutState)
  }

  constructor(
    private logService: LogService,
    private storageService: StorageService
  ) {
    // do nothing
  }

  init(): void {
    this.logService.info(`[StateDataService] Init`)

    this._deviceId = this.storageService.getString(this.deviceIdKey) ?? undefined
    this.deviceId$.next(this._deviceId)
    this._customerId = this.storageService.getString(this.customerIdKey) ?? undefined
    this._guestMode = this.storageService.getBoolean(this.guestModeKey) ?? false
    this._checkInState = this.storageService.getBoolean(this.checkInStateKey) ?? true
    this._checkOutState = this.storageService.getBoolean(this.checkOutStateKey) ?? true

    this.logService.info(`[StateDataService] deviceId = ${this.deviceId}`)
    this.logService.info(`[StateDataService] customerId = ${this.customerId}`)
    this.logService.info(`[StateDataService] guestMode = ${this.guestMode}`)
    this.logService.info(`[StateDataService] checkInState = ${this.checkInState}`)
    this.logService.info(`[StateDataService] checkOutState = ${this.checkOutState}`)
  }
}
